import { Component, OnInit } from '@angular/core';
import { ModalSendEmailComponent } from '../modal-send-email.component';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-input-email',
  templateUrl: './input-email.component.html',
  styleUrls: ['./input-email.component.css']
})
export class InputEmailComponent implements OnInit {

  public childInputIndex: number;

  public parentRef: ModalSendEmailComponent;

  public inputEmailCC: string;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
  }


  public deleteInputEmailCC() {   
    this.parentRef.deleteInputEmailCC(this.childInputIndex);
  }

}


// WEBPACK FOOTER //
// /app/src/app/office/laboratory-tests/modals/modal-send-email/input-email/input-email.component.ts